import { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
body{
    margin: 0;
    padding: 0;
    background: #ffffff;
    font-family: 'Roboto';
}
.flex-1 {
    flex: 1;
}
.centralized{
    display: flex;
    justify-content: center;
    align-items: center;
}

.centralized-flex-start{
    display: flex;
    justify-content: flex-start;
    align-items: center;
}

.centralized-column{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.centralized-space-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.centralized-space-evenly{
    display: flex;
    justify-content: space-evenly;
    align-items: center;
}
@media(max-width: 720px){
    .centralized-space-between{
        flex-direction: row;
    }
}
`;

export default GlobalStyle;
